import React from 'react'
import { ConfirmationDialog } from '../../Components/ConfirmationDialog'
import { ChildProps, graphql } from 'react-apollo'
import { CampaignStatus, deleteCampaignCollection } from '../../Api/campaigns'
import { get } from 'lodash'
import { SessionContext } from '../../Contexts/SessionContext'
import { MessageBar, MessageBarType } from 'office-ui-fabric-react'
import gql from 'graphql-tag'

interface State {
  isSubmitting: boolean
  hasError: boolean
}

interface InputProps {
  collectionId: string
  onClose: () => void
  onUpdated: () => void
}

interface CustomCampaignCollectionSummaryResponse {
  campaignCollections: {
    id: string
    title: string
    assets: {
      id: string
      title: string
      status: CampaignStatus
      eventCount: number
    }[]
  }[]
}

const getCustomCampaignCollectionSummaryQuery = gql`
  query ($collectionId: String!) {
    campaignCollections(byId: $collectionId) {
      id
      title
      assets {
        id
        title
        status
        eventCount
      }
    }
  }
`

class DeleteCampaignsCollectionDialogView extends React.Component<
  ChildProps<InputProps, CustomCampaignCollectionSummaryResponse>,
  State
> {
  static contextType = SessionContext
  context!: React.ContextType<typeof SessionContext>

  constructor(props: any) {
    super(props)
    this.state = {
      isSubmitting: false,
      hasError: false,
    }
  }
  render() {
    const collection = this.getCollection()
    if (!collection) {
      return <React.Fragment />
    }
    const activeCampaigns = collection.assets
      .filter((c) => c.status === 'live')
      .sort((a, b) => b.eventCount - a.eventCount)
    return (
      <ConfirmationDialog
        dialogTitle="Delete Campaign Collection"
        confirmationNode={
          <div>
            <p>
              Are you sure you want to delete campaign collection{' '}
              <strong>{collection.title}</strong>?
            </p>
            {activeCampaigns.length > 0 && (
              <div>
                <p>This collection contains active campaigns:</p>
                <ul>
                  {activeCampaigns.slice(0, 10).map((campaign) => (
                    <li key={campaign.id}>{campaign.title}</li>
                  ))}
                </ul>
              </div>
            )}
            <MessageBar messageBarType={MessageBarType.severeWarning}>
              This action is irreversible.
            </MessageBar>
          </div>
        }
        errorMessage={
          this.state.hasError
            ? 'Could not delete collection. If the problem persist, please contact support.'
            : undefined
        }
        yesButtonText="Yes"
        noButtonText="No"
        isLoading={this.state.isSubmitting}
        onCancel={this.props.onClose}
        onConfirm={() => this.submit()}
      />
    )
  }
  submit() {
    this.setState({ isSubmitting: true })
    deleteCampaignCollection(this.props.collectionId)
      .then(this.props.onUpdated)
      .then(() => {
        window.location.href = `${process.env.PUBLIC_URL}/#/${this.context.ctok}/campaigns/#/nav/campaigns/open`
        this.props.onClose()
      })
      .catch((e) => {
        console.error(e)
        this.setState({ isSubmitting: false, hasError: true })
      })
    return false
  }
  getCollection() {
    return get(this.props.data!, 'campaignCollections', []).find(
      (c) => c.id === this.props.collectionId
    )
  }
}

const withGql = graphql<InputProps, CustomCampaignCollectionSummaryResponse>(
  getCustomCampaignCollectionSummaryQuery,
  {
    options: ({ collectionId }) => ({
      notifyOnNetworkStatusChange: true,
      variables: { collectionId },
    }),
  }
)
export const DeleteCampaignsCollectionDialog = withGql(
  DeleteCampaignsCollectionDialogView
)
